import { render, staticRenderFns } from "./AddPotentialPolicyModal.vue?vue&type=template&id=62c9aae4&scoped=true&"
import script from "./AddPotentialPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AddPotentialPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPotentialPolicyModal.vue?vue&type=style&index=0&id=62c9aae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9aae4",
  null
  
)

export default component.exports